import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import type { User } from '../../types/user';

interface UserDialogProps {
  open: boolean;
  onClose: () => void;
  mode: 'view' | 'edit' | 'create';
  user?: User | null;
}

const UserDialog: React.FC<UserDialogProps> = ({ open, onClose, mode, user }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {mode === 'create' ? 'Create User' : 
         mode === 'edit' ? 'Edit User' : 'User Details'}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ flex: '1 1 250px', minWidth: '250px' }}>
              <TextField
                fullWidth
                label="First Name"
                variant="outlined"
                defaultValue={user?.firstName || ''}
                disabled={mode === 'view'}
              />
            </Box>
            <Box sx={{ flex: '1 1 250px', minWidth: '250px' }}>
              <TextField
                fullWidth
                label="Last Name"
                variant="outlined"
                defaultValue={user?.lastName || ''}
                disabled={mode === 'view'}
              />
            </Box>
          </Box>
          <Box>
            <TextField
              fullWidth
              label="Email"
              type="email"
              variant="outlined"
              defaultValue={user?.email || ''}
              disabled={mode === 'view'}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ flex: '1 1 250px', minWidth: '250px' }}>
              <FormControl fullWidth>
                <InputLabel>Role</InputLabel>
                <Select
                  label="Role"
                  defaultValue={user?.role || ''}
                  disabled={mode === 'view'}
                >
                  <MenuItem value="job_seeker">Job Seeker</MenuItem>
                  <MenuItem value="employer">Employer</MenuItem>
                  <MenuItem value="teacher">Teacher</MenuItem>
                  <MenuItem value="student">Student</MenuItem>
                  <MenuItem value="admin">Admin</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ flex: '1 1 250px', minWidth: '250px' }}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  defaultValue={user?.isActive !== undefined ? (user.isActive ? 'active' : 'inactive') : 'active'}
                  disabled={mode === 'view'}
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="suspended">Suspended</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        {mode !== 'view' && (
          <Button variant="contained">
            {mode === 'create' ? 'Create' : 'Save'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default UserDialog;
